export default "__VITE_ASSET__FVYNXWwi__"